// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".moving-images-image-input-answer[data-v-34f2229a]{display:flex;flex-direction:row;align-items:flex-start}.images[data-v-34f2229a]{max-height:200px;width:auto;height:auto;margin:0 5px}.no-image[data-v-34f2229a]{height:200px;min-width:200px;border:4px dashed #000;margin:0 5px}.images-container[data-v-34f2229a]{display:flex;flex-direction:row;align-items:flex-start}", ""]);
// Exports
module.exports = exports;
